module.exports = __webpack_public_path__ + "static/media/analytics.be61966b.svg";